import {IComponentOptions, IFilterService} from 'angular';
import {IStateService} from 'angular-ui-router';
import AuthServiceRS from '../../authentication/service/AuthServiceRS.rest';
import {TSRefreshEvent} from '../../core/events/TSRefreshEvent';
import BeitragRS from '../../core/service/BeitragRS';
import {PageNameConstants} from '../../core/service/PageNameConstants';
import RoleUtilService from '../../core/service/RoleUtilService';
import ZahlungsauftragRS from '../../core/service/ZahlungsauftragRS.rest';
import {TSBeitragStatus} from '../../models/enums/TSBeitragStatus';
import {TSBeitragType} from '../../models/enums/TSBeitragType';
import TSBeitraegeSearchresultDTO from '../../models/TSBeitraegeSearchresultDTO';
import TSBeitrag from '../../models/TSBeitrag';
import TSBeitragDTO from '../../models/TSBeitragDTO';
import TSBeitragPreFilterDTO from '../../models/TSBeitragPreFilterDTO';
import TSBenutzer from '../../models/TSBenutzer';
import TSUser from '../../models/TSUser';
import TSZahlungsauftraegeSearchresultDTO from '../../models/TSZahlungsauftraegeSearchresultDTO';
import TSZahlungsauftragDTO from '../../models/TSZahlungsauftragDTO';
import ILogService = angular.ILogService;
import IPromise = angular.IPromise;
import IQService = angular.IQService;
import IScope = angular.IScope;

declare let require: any;
let template = require('./zahlungenListView.html');

export class ZahlungenListViewComponentConfig implements IComponentOptions {
    transclude = false;
    template = template;
    controller = ZahlungenListViewController;
    controllerAs = 'vm';
    bindToController = true;
    bindings: any = {
        besitzer: '<'
    };

}

export class ZahlungenListViewController {

    private zahlungenList: Array<TSBeitragDTO>;
    private zahlungsauftragList: Array<TSZahlungsauftragDTO>;
    totalResultCount: string = '-';
    tabs: any[] = [];
    selectedPrefilter: TSBeitragPreFilterDTO | undefined;
    selectedTab: number = 0;
    currentPrincipal: TSUser | undefined;
    currentUsername: string | undefined;
    emptyFilter: TSBeitragPreFilterDTO;
    besitzer: Array<TSBenutzer>;

    static $inject: string[] = ['$filter', '$state', '$log', 'CONSTANTS', '$q', 'BeitragRS', '$scope', 'AuthServiceRS', 'RoleUtilService',
        'ZahlungsauftragRS', 'PAGE_NAMES'];

    constructor(private $filter: IFilterService,
                private $state: IStateService, private $log: ILogService, private CONSTANTS: any,
                private $q: IQService, private beitragRS: BeitragRS, private $scope: IScope, private authService: AuthServiceRS,
                private roleUtilService: RoleUtilService, private zahlungsauftragRS: ZahlungsauftragRS, private pageNames: PageNameConstants) {

    }

    $onInit() {
        this.currentPrincipal = this.authService.getPrincipal();
        this.currentUsername = (this.currentPrincipal !== undefined) ? this.currentPrincipal.email : undefined;
        this.emptyFilter = new TSBeitragPreFilterDTO(undefined);
        this.initViewModel();
    }

    private initViewModel() {
        this.tabs.push({
            title: 'NICHT_FREIGEGEBEN',
            prefilter: new TSBeitragPreFilterDTO(TSBeitragStatus.NICHT_FREIGEGEBEN),
            freigeben: true,
            ausfuehren: false
        });
        this.tabs.push({
            title: 'PENDENT',
            prefilter: new TSBeitragPreFilterDTO(TSBeitragStatus.PENDENT),
            freigeben: false,
            ausfuehren: true
        });

        this.selectedPrefilter = this.tabs[this.selectedTab].prefilter;

    }

    public passBeitragFilterToServer = (tableFilterState: any, prefilter: TSBeitragPreFilterDTO): IPromise<TSBeitraegeSearchresultDTO> => {
        this.$log.debug('Triggering ServerFiltering with Filter Object', tableFilterState);
        return this.beitragRS.searchBeitraege(tableFilterState, prefilter).then((response: TSBeitraegeSearchresultDTO) => {
            this.totalResultCount = response.totalResultSize ? response.totalResultSize.toString() : '-';
            this.zahlungenList = response.schadenfallBeitragDTOs;
            return response;
        });
    };

    public passZahlungsauftragFilterToServer = (tableFilterState: any): IPromise<TSZahlungsauftraegeSearchresultDTO> => {
        this.$log.debug('Triggering ServerFiltering with Filter Object', tableFilterState);
        return this.zahlungsauftragRS.searchZahlungsauftraege(tableFilterState).then((response: TSZahlungsauftraegeSearchresultDTO) => {
            this.totalResultCount = response.totalResultSize ? response.totalResultSize.toString() : '-';
            this.zahlungsauftragList = response.zahlungsauftragDTOs;
            return response;
        });
    };

    public getZahlungenList(): Array<TSBeitragDTO> {
        return this.zahlungenList;
    }

    private selectTab(selected: any) {
        this.selectedPrefilter = this.tabs[selected] ? this.tabs[selected].prefilter : undefined;
        this.selectedTab = selected;
        // trigger refresh of smartTable
        this.$scope.$broadcast(TSRefreshEvent[TSRefreshEvent.REFRESH_ST_TABLE]);
    }

    private editFall(beitragDTO: any, event: any) {

        if (beitragDTO.beitragType === TSBeitragType.SCHADENFALL) {
            this.$state.go(this.pageNames.SCHADENMELDUNG, {schadenfallId: beitragDTO.schadenfallId});
        } else {
            this.$state.go('versicherungsbeitragschaden', {versicherungsbeitragId: beitragDTO.schadenfallId, createNew: false});
        }
    }

    private editBeitrag(beitragDTO: TSBeitragDTO, beitrag: TSBeitrag, event: any) {
        if (beitragDTO.beitragType === TSBeitragType.SCHADENFALL) {
            this.$state.go(this.pageNames.ENTSCHAEDIGUNG, {schadenfallId: beitragDTO.schadenfallId});
        } else {
            this.$state.go('versicherungbeitragbeitrag', {versicherungsbeitragId: beitragDTO.schadenfallId});
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/zahlungen/component/zahlungenListView.ts